import { render } from "./DoorpostScene.vue?vue&type=template&id=679104b8&scoped=true"
import script from "./DoorpostScene.vue?vue&type=script&lang=js"
export * from "./DoorpostScene.vue?vue&type=script&lang=js"

import "./DoorpostScene.vue?vue&type=style&index=0&id=679104b8&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679104b8"]])

export default __exports__